<div class="screen-spacer"></div>

<div class="detail-wrapper page-content" [ngClass]="getClass() + ' ' + pageName">
	<app-is-in-view class="is-in-view" ></app-is-in-view>
	<ng-container *ngIf="(currentTaxonomyPage$ | push) as item">
		<ng-container *ngFor="let article of [item]">

			<app-article class="article" [article]="article" ></app-article>

		</ng-container>
	</ng-container>

	<ng-container>
		<div class="main-content" [class.disabled]="(hasContent$ | push) === false" >

			<app-scroll-into-view class="scroll-into-view" [id]="pageName"></app-scroll-into-view>

			<!-- <app-filters [facets$]="filters$"></app-filters> -->

			<app-data 
				[displayPage]="true"
				[dataSource]="{storeName: pageName, id: '', static: false}"
			>
				<ng-template 
					#optionTemplate 
					let-articles$="articles$"
					let-count$="count$" 
					let-status$="status$"
					let-pageParams$="pageParams$"
					let-displayPage="displayPage"
					let-scrollInToView$="scrollInToView$"
					let-pager$="pager$"
				>
					<app-loader class="loader" [status$]="status$"></app-loader>
					
					<app-search-bar 
						[count$]="count$"
						[status$]="status$" 
						[articles$]="articles$" 
						[pageParams$]="pageParams$"
						[pageName]="pageName"
						[scrollInToView$]="scrollInToView$"
						[class]="class"						
					></app-search-bar>

					<div class="grid-wrapper" [ngClass]="class"> 

						<app-grid 
							[articles$]="articles$" 
							[displayPage]="displayPage"
							[queryParams$]="queryParams$"
						></app-grid>

						<app-pager 
							[status$]="status$" 
							[pager$]="pager$"
						></app-pager>
					
					</div>
				</ng-template>
			</app-data>
		</div>
	</ng-container>
	
	<!-- <nav class="back-btn">
		<app-back-btn 
			class="detail-back-btn" 
			[currentTaxonomyPage$]="currentTaxonomyPage$"
			[route$]="route$"
			[showIcon]="false"
		></app-back-btn>
	</nav> -->

</div>

<app-page-bottom></app-page-bottom>


  